<template>
<div class="root_work">
  <div class="hecheng_work">
    
    <div class="hecheng-content_work">
      

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/' }">视频工作台</el-breadcrumb-item>
      </el-breadcrumb>

      <el-alert
        title="因服务器资源有限，待生成的视频内容较多，需要等待时间较长，敬请谅解！"
        type="warning"
        show-icon>
      </el-alert>

      <div class="work_table">
          <el-table
          :data="list.data"
          stripe
          style="width: 100%">

          <el-table-column
            prop="id"
            label="任务ID"
            width="80">
          </el-table-column>

          <el-table-column
            
            label="主播"
            width="180">
            <template slot-scope="scope">
              <div  class="anchor-info">
                  <div  class="icon">
                      <img  :src="scope.row.anchor.pic">
                  </div>
                  <div>
                      <div class="name"> {{scope.row.anchor.name}} </div>
                      <div class="character">{{ scope.row.anchor.desc }}</div>
                  </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="content"
            class-name="t_cont"
            width="400"
            label="内容">
          </el-table-column>

          <el-table-column
          
            label="音频">
            <template slot-scope="scope">
              <el-link :href="scope.row.downAudioUrl" type="primary">下载音频</el-link>
            </template>
          </el-table-column>

          <el-table-column
            prop="srt"
            label="字幕">
            <template slot-scope="scope">
              <el-link :href="scope.row.downSrtUrl" type="primary">下载字幕</el-link>
            </template>
          </el-table-column>

          <el-table-column
            prop="video"
            label="视频">
            <template slot-scope="scope">
              <el-link :href="scope.row.downVideoUrl" type="primary">下载视频</el-link>
            </template>
          </el-table-column>

          <el-table-column
            prop="statusName"
            label="状态">
          </el-table-column>

        </el-table>

        <div class="pager">
          <el-pagination v-if="page.total>page.per_page"
            background
            layout="prev, pager, next"
            :current-page="page.current_page"
            :total="page.total"
            :page-size="page.per_page"
            @current-change="gopage"
            >
          </el-pagination>
        </div>
      </div>

  

    </div>

  </div>
</div>

</template>
<style >
.pager{
  padding:15px 0;
  text-align:center;
}

.root_work{
  background: #f2f3f5;
  padding:16px 0;
}
.hecheng_work{
  width:82%;
  background:#fff;

  border:2px solid rgba(237,237,237,1);
  border-radius:10px;
  margin: 0px auto;
}


.hecheng-content_work{

  padding:10px;
}

.work_table{
  margin-top:40px;
  min-height:400px;
}
td.t_cont div{
  height: 200px;
  overflow-y: scroll!important;
}

</style>
<script>
import { Message } from 'element-ui';


export default {
  data(){
    return{
      activeIndex:"7",
      list:[],
      page:{
        
      }
    }
  },
  created () {
    
  },
  mounted() {

     this.$store.commit("setActiveIndex",this.activeIndex);
     this.getList(1);
     
  },
  methods:{    
    gopage(p){
        this.getList(p)
    },

    getList(p){
      this.axios({
        method: "post",
        url: "/api/tts/work_list?page="+p,
        data: {
        },
      }).then((res) => {
        if(res.data.code==200){
          let ls = res.data.data

          for(var i in ls.data){
          
            if(ls.data[i].status == 0){
              ls.data[i].statusName = "等待中";
            }else if(ls.data[i].status == 4){
              ls.data[i].statusName = "已完成";
            }else{
              ls.data[i].statusName = "生成中";
            }
          }

          this.list = ls
          let pg = {
            current_page:res.data.data.current_page,
            total:Number(res.data.data.total),
            per_page:res.data.data.per_page,
            path:res.data.data.path
          }
          this.page = pg
          console.log(this.page)
        }else{
           that.$message.error(res.data.msg);
        }
      
      })
    }
    
  }
}
</script>